// extracted by mini-css-extract-plugin
export default {"leftNav":"index_leftNav_54OH7","webLogo":"index_webLogo_issHM","navBg":"index_navBg_caTJG","nav_img":"index_nav_img_l3bXK"};